import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {faMapPin, faTrash} from '@fortawesome/free-solid-svg-icons';
import {Contact} from '../../../services/contact';
import {DebtorsService} from '../../../services/debtors.service';
import {CreditorsService} from '../../../services/creditors.service';
import {Order} from '../../../services/order';
import {TenFourOrderService} from '../../../services/themes/10-4/ten-four-order.service';
import {CONTACT_TYPES_IDS} from '../../../../config/constants-10-4';

@Component({
    selector: 'app-change-order-delivery-contact',
    templateUrl: './change-order-delivery-contact.component.html',
    styleUrls: ['./change-order-delivery-contact.component.scss']
})
export class ChangeOrderDeliveryContactComponent implements OnInit {

    pinIcon = faMapPin;
    deleteIcon = faTrash;

    currentDeliveryContact: Contact | null;
    showContactSearchResults: boolean;
    contactSearchResult: Contact[] | null;
    filteredSearchResults: Contact[] | null;
    loading: boolean;
    _order: Order | null | undefined;

    @Output() didChangeDeliveryContact = new EventEmitter<boolean>();


    constructor(public orderService: TenFourOrderService, public debtorService: DebtorsService, public creditorService: CreditorsService) {
        this.showContactSearchResults = false;
        this.contactSearchResult = null;
        this.loading = false;
        this.currentDeliveryContact = null;
    }

    ngOnInit(): void {
        this.orderService.currentOrder.subscribe(response => {
            this._order = response;
            this.currentDeliveryContact = this._order.getContactWithTypeId(CONTACT_TYPES_IDS.DELIVERY_ADDRESS);
        });

        this.showContactSearchResults = true;

        this.load();
    }

    load(): void {
        this.loading = true;

        if (this._order.isCreditor()) {
            this.creditorService.getCreditor(this._order.creditor_id, true, false, true, false, false).subscribe(response => {
                this.contactSearchResult = response.data.contacts;
                this.filteredSearchResults = response.data.contacts;
                this.loading = false;
            });
        } else {
            this.debtorService.getDebtor(this._order.debtor_id, {
                withContacts: true
            }).subscribe(response => {
                this.contactSearchResult = response.data.contacts;
                this.filteredSearchResults = response.data.contacts;
                this.loading = false;
            });
        }
    }

    onClick(contact: Contact): void {
        this.loading = true;

        const previousDebtor = this._order.debtor;
        const previousCreditor = this._order.creditor;

        const newContact = Object.assign(new Contact(), contact);
        newContact.contact_type_id = CONTACT_TYPES_IDS.DELIVERY_ADDRESS;

        delete newContact._joinData;
        delete newContact.contact_type;

        this._order = this.orderService.setNewContact(this._order, newContact);
        if (this._order.id){
            this.orderService.updateOrder(this._order).subscribe((response) => {
                this.loading = false;
                this.filteredSearchResults = [];
                this.showContactSearchResults = false;

                response.data.debtor = response.data.debtor || previousDebtor;
                response.data.creditor = response.data.creditor || previousCreditor;

                this.orderService.setOrder(response.data);
                this.didChangeDeliveryContact.emit(true);
            });
        } else {
            this.loading = false;
            this.filteredSearchResults = [];
            this.showContactSearchResults = false;
            this.orderService.setOrder(this._order);
            this.didChangeDeliveryContact.emit(true);
        }
    }

    delete(contact: Contact): void {
        if (confirm('Er du sikker på at du vil slette denne leveringsadresse?')) {
            this.loading = true;

            this.debtorService.deleteDebtorsContact(contact._joinData.id).subscribe(_ => {
                this.loading = false;
                this.load();
            });
        }
    }

    onContactSearchInputChange(val: string): void {
        const query = val.toLowerCase();

        if (query === '') {
            this.filteredSearchResults = this.contactSearchResult;
            return;
        }

        this.filteredSearchResults = this.contactSearchResult.filter((c) => {
            return c.name?.toLowerCase().includes(query)
                || c.nickname?.toLowerCase().includes(query)
                || c.contact_fields.some(f => f._joinData?.value?.toLowerCase().includes(query));
        });
    }
}
